module.exports = __webpack_public_path__ + "assets/img/banner_大会标题@2x.7ee42893.png";